import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { onUnmounted, ref } from 'vue'

/**
 * This component is an item inside an action menu dropdown menu.
 * It's meant to be used inside the default slot of the `ActionMenu` component.
 *
 * @param icon - An iconfont icon class name.
 * @param href - A link. Passing this prop converts the item
 *   from a button into a link (`<a>`).
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionMenuItem',
  props: {
    icon: null,
    href: null
  },
  setup(__props: any) {



const isDisabled = ref(false)
const disabledTimeout = ref<number | null>(null)

function preventDoubleClick(): void {
  isDisabled.value = true

  disabledTimeout.value = setTimeout(() => {
    isDisabled.value = false
  }, 500)
}

onUnmounted(() => {
  if (disabledTimeout.value) {
    clearTimeout(disabledTimeout.value)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: "action-menu__item-wrapper",
    onClick: preventDoubleClick
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.href ? 'a' : 'button'), {
      class: "action-menu__item",
      href: __props.href,
      target: "_blank",
      disabled: isDisabled.value
    }, {
      default: _withCtx(() => [
        (__props.icon)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["iconfont", __props.icon])
            }, null, 2))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["href", "disabled"]))
  ]))
}
}

})